import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/zh2';
export const locale = {
  lang: 'zh2',
  data: {
    'CONSULTA': {
      'CATALOGOS': {
        'broker': catalogos.institutos,
        'PRODUCTOS': catalogos.productos,
      },
      'TITULO': '调查日历',
       'SUBTITULO': '查询特定范围内平台生成的调查信息。',
       'TXT_RANG_DAT':'输入日期范围',
       'BTN_CANC':'取消',
       'BTN_APLI':'应用',
       'MOD_TITT_INFO':'调查信息',
       'TXT_NAM_COMPA':'公司名称：  ',
       'TXT_NAM_TOKEN':'调查令牌:  ',
       'TXT_DAT_LAN':'发布日期：  ',
       'TXT_DAT_CLOS':'截止日期：  ',
       'TXT_SUR_STA':'调查调查状态：  ',
       'TXT_TIP_SUR':'产品类型：  ',
       'TXT_YEA_SUR':'调查年份：  ',
       'ESTATUS':{
         '0':'不活动',
         '1':'活跃',
         '2':'关闭',
       },
      'CAMPOS': {
        'broker': 'Broker',
      },
    }
  }
};
